export * from './dynamic-pricing-rule-form.component';
